export var AgencyFlags;
(function (AgencyFlags) {
  AgencyFlags["REI_LOGO_ACT"] = "REI_LOGO_ACT";
  AgencyFlags["REI_LOGO_NSW"] = "REI_LOGO_NSW";
})(AgencyFlags || (AgencyFlags = {}));
export var AgentListingRequestType;
(function (AgentListingRequestType) {
  AgentListingRequestType["ALL"] = "ALL";
  AgentListingRequestType["OTHER_LISTINGS"] = "OTHER_LISTINGS";
})(AgentListingRequestType || (AgentListingRequestType = {}));
export var AgentListingType;
(function (AgentListingType) {
  AgentListingType["RENTALS"] = "RENTALS";
  AgentListingType["RENTED"] = "RENTED";
  AgentListingType["SALES"] = "SALES";
  AgentListingType["SOLD"] = "SOLD";
})(AgentListingType || (AgentListingType = {}));
export var AgentSearchSortStatus;
(function (AgentSearchSortStatus) {
  AgentSearchSortStatus["ACTIVE"] = "ACTIVE";
  AgentSearchSortStatus["COMPLETED"] = "COMPLETED";
})(AgentSearchSortStatus || (AgentSearchSortStatus = {}));
export var AgentSearchSortType;
(function (AgentSearchSortType) {
  AgentSearchSortType["DEVELOPMENT"] = "DEVELOPMENT";
  AgentSearchSortType["RENT"] = "RENT";
  AgentSearchSortType["SELL"] = "SELL";
})(AgentSearchSortType || (AgentSearchSortType = {}));
export var AgentType;
(function (AgentType) {
  AgentType["AGENT"] = "AGENT";
  AgentType["PRIVATE_LISTER"] = "PRIVATE_LISTER";
})(AgentType || (AgentType = {}));
export var ApplyOnlineProvider;
(function (ApplyOnlineProvider) {
  ApplyOnlineProvider["ONEFORM"] = "ONEFORM";
  ApplyOnlineProvider["SNUG"] = "SNUG";
  ApplyOnlineProvider["SORTED_SERVICES"] = "SORTED_SERVICES";
  ApplyOnlineProvider["TENAPP"] = "TENAPP";
})(ApplyOnlineProvider || (ApplyOnlineProvider = {}));
export var ArticleAuthorType;
(function (ArticleAuthorType) {
  ArticleAuthorType["CONTRIBUTOR"] = "CONTRIBUTOR";
  ArticleAuthorType["DOMAIN"] = "DOMAIN";
})(ArticleAuthorType || (ArticleAuthorType = {}));
export var ArticleTagType;
(function (ArticleTagType) {
  ArticleTagType["CATEGORY"] = "CATEGORY";
  ArticleTagType["TAG"] = "TAG";
})(ArticleTagType || (ArticleTagType = {}));
export var AuctionResult;
(function (AuctionResult) {
  AuctionResult["PASSED_IN"] = "PASSED_IN";
  AuctionResult["PRIVATE_EXCHANGE"] = "PRIVATE_EXCHANGE";
  AuctionResult["SOLD"] = "SOLD";
  AuctionResult["SOLD_PRIOR"] = "SOLD_PRIOR";
  AuctionResult["UNKNOWN"] = "UNKNOWN";
  AuctionResult["WITHDRAWN"] = "WITHDRAWN";
})(AuctionResult || (AuctionResult = {}));
export var AutocompleteType;
(function (AutocompleteType) {
  AutocompleteType["ADDRESS"] = "ADDRESS";
  AutocompleteType["AGENCY"] = "AGENCY";
  AutocompleteType["AGENT"] = "AGENT";
  AutocompleteType["DEVELOPMENT"] = "DEVELOPMENT";
  AutocompleteType["DISTRICT"] = "DISTRICT";
  AutocompleteType["DIVISION"] = "DIVISION";
  AutocompleteType["POSTCODE"] = "POSTCODE";
  AutocompleteType["REGION"] = "REGION";
  AutocompleteType["SCHOOL"] = "SCHOOL";
  AutocompleteType["STREET"] = "STREET";
})(AutocompleteType || (AutocompleteType = {}));
export var Badge;
(function (Badge) {
  Badge["development"] = "development";
  Badge["displayHome"] = "displayHome";
  Badge["featuredProperty"] = "featuredProperty";
  Badge["fullyFurnished"] = "fullyFurnished";
  Badge["new"] = "new";
  Badge["newLand"] = "newLand";
  Badge["overFiftyFiveEnabled"] = "overFiftyFiveEnabled";
  Badge["overSixtyEnabled"] = "overSixtyEnabled";
  Badge["priceReduced"] = "priceReduced";
  Badge["propertyOfTheWeek"] = "propertyOfTheWeek";
  Badge["rented"] = "rented";
  Badge["sold"] = "sold";
  Badge["topSpot"] = "topSpot";
  Badge["underApplication"] = "underApplication";
  Badge["underOffer"] = "underOffer";
})(Badge || (Badge = {}));
export var BookInspectionProvider;
(function (BookInspectionProvider) {
  BookInspectionProvider["BOOKABILITY"] = "BOOKABILITY";
  BookInspectionProvider["HOMEPASS"] = "HOMEPASS";
  BookInspectionProvider["IRE"] = "IRE";
  BookInspectionProvider["SNUG"] = "SNUG";
})(BookInspectionProvider || (BookInspectionProvider = {}));
export var CacheControlScope;
(function (CacheControlScope) {
  CacheControlScope["PRIVATE"] = "PRIVATE";
  CacheControlScope["PUBLIC"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
export var DurationType;
(function (DurationType) {
  DurationType["ALL"] = "ALL";
  DurationType["MONTHS"] = "MONTHS";
  DurationType["SPECIFIC_YEAR"] = "SPECIFIC_YEAR";
  DurationType["WEEKS"] = "WEEKS";
  DurationType["YEARS"] = "YEARS";
})(DurationType || (DurationType = {}));
export var EventType;
(function (EventType) {
  EventType["AUCTION"] = "AUCTION";
  EventType["INSPECTION"] = "INSPECTION";
})(EventType || (EventType = {}));
export var FollowedPropertyRelationship;
(function (FollowedPropertyRelationship) {
  FollowedPropertyRelationship["CURIOUS"] = "CURIOUS";
  FollowedPropertyRelationship["LANDLORD"] = "LANDLORD";
  FollowedPropertyRelationship["OWNER"] = "OWNER";
  FollowedPropertyRelationship["TENANT"] = "TENANT";
})(FollowedPropertyRelationship || (FollowedPropertyRelationship = {}));
export var GroupStatsClient;
(function (GroupStatsClient) {
  GroupStatsClient["AGENT_ADMIN"] = "AGENT_ADMIN";
  GroupStatsClient["ANDROID"] = "ANDROID";
  GroupStatsClient["IPAD"] = "IPAD";
  GroupStatsClient["IPHONE"] = "IPHONE";
  GroupStatsClient["UNKNOWN"] = "UNKNOWN";
  GroupStatsClient["WEBSITE"] = "WEBSITE";
  GroupStatsClient["WEBSITE_DESKTOP"] = "WEBSITE_DESKTOP";
  GroupStatsClient["WEBSITE_MOBILE"] = "WEBSITE_MOBILE";
  GroupStatsClient["WEBSITE_TABLET"] = "WEBSITE_TABLET";
})(GroupStatsClient || (GroupStatsClient = {}));
export var GroupStatsEventBrand;
(function (GroupStatsEventBrand) {
  GroupStatsEventBrand["Allhomes"] = "Allhomes";
  GroupStatsEventBrand["CRE"] = "CRE";
  GroupStatsEventBrand["Domain"] = "Domain";
  GroupStatsEventBrand["Homepass"] = "Homepass";
  GroupStatsEventBrand["Pricefinder"] = "Pricefinder";
})(GroupStatsEventBrand || (GroupStatsEventBrand = {}));
export var GroupStatsPlatform;
(function (GroupStatsPlatform) {
  GroupStatsPlatform["Admin"] = "Admin";
  GroupStatsPlatform["Agent"] = "Agent";
  GroupStatsPlatform["Android"] = "Android";
  GroupStatsPlatform["Website"] = "Website";
  GroupStatsPlatform["iPad"] = "iPad";
  GroupStatsPlatform["iPhone"] = "iPhone";
})(GroupStatsPlatform || (GroupStatsPlatform = {}));
export var HistorySortType;
(function (HistorySortType) {
  HistorySortType["PRICE"] = "PRICE";
  HistorySortType["SOLD_AGE"] = "SOLD_AGE";
})(HistorySortType || (HistorySortType = {}));
export var KeyDetailType;
(function (KeyDetailType) {
  KeyDetailType["area"] = "area";
  KeyDetailType["infoLink"] = "infoLink";
  KeyDetailType["simple"] = "simple";
})(KeyDetailType || (KeyDetailType = {}));
export var ListingStatusType;
(function (ListingStatusType) {
  ListingStatusType["APPRAISAL"] = "APPRAISAL";
  ListingStatusType["FOR_RENT"] = "FOR_RENT";
  ListingStatusType["FOR_SALE"] = "FOR_SALE";
  ListingStatusType["POTENTIAL_LISTING"] = "POTENTIAL_LISTING";
  ListingStatusType["RENTED"] = "RENTED";
  ListingStatusType["SOLD"] = "SOLD";
  ListingStatusType["UNDER_APPLICATION"] = "UNDER_APPLICATION";
  ListingStatusType["UNDER_OFFER"] = "UNDER_OFFER";
  ListingStatusType["WITHDRAWN"] = "WITHDRAWN";
})(ListingStatusType || (ListingStatusType = {}));
export var ListingType;
(function (ListingType) {
  ListingType["DEVELOPMENTS_RESIDENTIAL"] = "DEVELOPMENTS_RESIDENTIAL";
  ListingType["OFF_MARKET"] = "OFF_MARKET";
  ListingType["RENTAL_COMMERCIAL"] = "RENTAL_COMMERCIAL";
  ListingType["RENTAL_RESIDENTIAL"] = "RENTAL_RESIDENTIAL";
  ListingType["SALES_BUSINESS"] = "SALES_BUSINESS";
  ListingType["SALES_COMMERCIAL"] = "SALES_COMMERCIAL";
  ListingType["SALES_EARLY_ACCESS"] = "SALES_EARLY_ACCESS";
  ListingType["SALES_RESIDENTIAL"] = "SALES_RESIDENTIAL";
  ListingType["SHARE_RESIDENTIAL"] = "SHARE_RESIDENTIAL";
})(ListingType || (ListingType = {}));
export var LocalityType;
(function (LocalityType) {
  LocalityType["DISTRICT"] = "DISTRICT";
  LocalityType["DIVISION"] = "DIVISION";
  LocalityType["POSTCODE"] = "POSTCODE";
  LocalityType["REGION"] = "REGION";
  LocalityType["SCHOOL"] = "SCHOOL";
  LocalityType["STREET"] = "STREET";
})(LocalityType || (LocalityType = {}));
export var MediaType;
(function (MediaType) {
  MediaType["COVER_SHOT"] = "COVER_SHOT";
  MediaType["FLOORPLAN"] = "FLOORPLAN";
  MediaType["PHOTO"] = "PHOTO";
  MediaType["VIDEO"] = "VIDEO";
  MediaType["VIRTUAL_TOUR"] = "VIRTUAL_TOUR";
})(MediaType || (MediaType = {}));
export var MedianPriceType;
(function (MedianPriceType) {
  MedianPriceType["APARTMENT"] = "APARTMENT";
  MedianPriceType["HOUSE"] = "HOUSE";
})(MedianPriceType || (MedianPriceType = {}));
export var NbnBrand;
(function (NbnBrand) {
  NbnBrand["FAST"] = "FAST";
  NbnBrand["SATELLITE"] = "SATELLITE";
  NbnBrand["ULTRAFAST"] = "ULTRAFAST";
  NbnBrand["UNKNOWN"] = "UNKNOWN";
  NbnBrand["WIRELESS"] = "WIRELESS";
})(NbnBrand || (NbnBrand = {}));
export var PointOfInterestType;
(function (PointOfInterestType) {
  PointOfInterestType["COLLEGE"] = "COLLEGE";
  PointOfInterestType["HIGH_SCHOOL"] = "HIGH_SCHOOL";
  PointOfInterestType["HOSPITAL"] = "HOSPITAL";
  PointOfInterestType["POST_OFFICE"] = "POST_OFFICE";
  PointOfInterestType["PRIMARY_SCHOOL"] = "PRIMARY_SCHOOL";
  PointOfInterestType["SHOPPING_CENTRE"] = "SHOPPING_CENTRE";
  PointOfInterestType["TAFE"] = "TAFE";
  PointOfInterestType["UNIVERSITY"] = "UNIVERSITY";
})(PointOfInterestType || (PointOfInterestType = {}));
export var PropertyType;
(function (PropertyType) {
  PropertyType["APARTMENT"] = "APARTMENT";
  PropertyType["BUSINESS"] = "BUSINESS";
  PropertyType["CHALET"] = "CHALET";
  PropertyType["COMMERCIAL_LAND"] = "COMMERCIAL_LAND";
  PropertyType["COMMERCIAL_STUDIO"] = "COMMERCIAL_STUDIO";
  PropertyType["COTTAGE"] = "COTTAGE";
  PropertyType["COURTYARD_HOME"] = "COURTYARD_HOME";
  PropertyType["DEVELOPMENT"] = "DEVELOPMENT";
  PropertyType["DUAL_OCCUPANCY"] = "DUAL_OCCUPANCY";
  PropertyType["DUPLEX"] = "DUPLEX";
  PropertyType["HOTEL"] = "HOTEL";
  PropertyType["HOUSE"] = "HOUSE";
  PropertyType["HOUSE_AND_LAND_PACKAGE"] = "HOUSE_AND_LAND_PACKAGE";
  PropertyType["INDUSTRIAL"] = "INDUSTRIAL";
  PropertyType["INVESTMENT_PROPERTY"] = "INVESTMENT_PROPERTY";
  PropertyType["LAND"] = "LAND";
  PropertyType["MOTEL"] = "MOTEL";
  PropertyType["OFFICE"] = "OFFICE";
  PropertyType["OTHER"] = "OTHER";
  PropertyType["OTHER_COMMERCIAL"] = "OTHER_COMMERCIAL";
  PropertyType["PROPERTY"] = "PROPERTY";
  PropertyType["RELOCATABLE_HOME"] = "RELOCATABLE_HOME";
  PropertyType["RESIDENTIAL_WAREHOUSE"] = "RESIDENTIAL_WAREHOUSE";
  PropertyType["RETAIL"] = "RETAIL";
  PropertyType["RETIREMENT_VILLAGE"] = "RETIREMENT_VILLAGE";
  PropertyType["RURAL"] = "RURAL";
  PropertyType["TOWNHOUSE"] = "TOWNHOUSE";
  PropertyType["TRI_OCCUPANCY"] = "TRI_OCCUPANCY";
  PropertyType["UNIT"] = "UNIT";
  PropertyType["UNKNOWN"] = "UNKNOWN";
  PropertyType["VILLA"] = "VILLA";
  PropertyType["WAREHOUSE"] = "WAREHOUSE";
})(PropertyType || (PropertyType = {}));
export var RentalType;
(function (RentalType) {
  RentalType["COMMERCIAL"] = "COMMERCIAL";
  RentalType["HOLIDAY"] = "HOLIDAY";
  RentalType["RESIDENTIAL"] = "RESIDENTIAL";
})(RentalType || (RentalType = {}));
export var ResponseStatus;
(function (ResponseStatus) {
  ResponseStatus["FAILED"] = "FAILED";
  ResponseStatus["OK"] = "OK";
})(ResponseStatus || (ResponseStatus = {}));
export var ReviewType;
(function (ReviewType) {
  ReviewType["BROWSER"] = "BROWSER";
  ReviewType["BUYER"] = "BUYER";
  ReviewType["OTHER"] = "OTHER";
  ReviewType["VENDOR"] = "VENDOR";
})(ReviewType || (ReviewType = {}));
export var SaleMethodType;
(function (SaleMethodType) {
  SaleMethodType["AUCTION"] = "AUCTION";
  SaleMethodType["EXPRESSION_OF_INTEREST"] = "EXPRESSION_OF_INTEREST";
  SaleMethodType["PRIVATE_TREATY"] = "PRIVATE_TREATY";
  SaleMethodType["TENDER"] = "TENDER";
})(SaleMethodType || (SaleMethodType = {}));
export var SchoolCampusType;
(function (SchoolCampusType) {
  SchoolCampusType["HEAD_CAMPUS"] = "HEAD_CAMPUS";
  SchoolCampusType["SINGLE_ENTITY"] = "SINGLE_ENTITY";
  SchoolCampusType["SUB_CAMPUS"] = "SUB_CAMPUS";
})(SchoolCampusType || (SchoolCampusType = {}));
export var SchoolGender;
(function (SchoolGender) {
  SchoolGender["BOYS"] = "BOYS";
  SchoolGender["COED"] = "COED";
  SchoolGender["GIRLS"] = "GIRLS";
})(SchoolGender || (SchoolGender = {}));
export var SchoolGeolocationType;
(function (SchoolGeolocationType) {
  SchoolGeolocationType["INNER_REGIONAL"] = "INNER_REGIONAL";
  SchoolGeolocationType["MAJOR_CITIES"] = "MAJOR_CITIES";
  SchoolGeolocationType["OUTER_REGIONAL"] = "OUTER_REGIONAL";
  SchoolGeolocationType["REMOTE"] = "REMOTE";
  SchoolGeolocationType["VERY_REMOTE"] = "VERY_REMOTE";
})(SchoolGeolocationType || (SchoolGeolocationType = {}));
export var SchoolSector;
(function (SchoolSector) {
  SchoolSector["CATHOLIC"] = "CATHOLIC";
  SchoolSector["GOVERNMENT"] = "GOVERNMENT";
  SchoolSector["INDEPENDENT"] = "INDEPENDENT";
})(SchoolSector || (SchoolSector = {}));
export var SchoolType;
(function (SchoolType) {
  SchoolType["COMBINED"] = "COMBINED";
  SchoolType["PRIMARY"] = "PRIMARY";
  SchoolType["SECONDARY"] = "SECONDARY";
  SchoolType["SPECIAL"] = "SPECIAL";
})(SchoolType || (SchoolType = {}));
export var SortOrder;
(function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));